<template>
  <div>
  <a @click="editPlanTreatment"
     class="tdclickable"
     v-if="hasRightToEditPlan && planTreatment">
    {{ planTreatment.message }}
  </a>
    <span v-else>{{ planTreatment.message }}</span>
  </div>
</template>

<script setup>
import { useStore } from "vuex"
import { computed } from "vue"
import {useRouter} from "vue-router"

const props = defineProps({
  object: {
    type: Object
  },
})

const store = useStore()
const router = useRouter()

const planTreatment = computed(() => props.object.plan_treatment || props.object)
const rights = computed(() => store.state.auth.rights)
const hasRightToEditPlan = computed(() => rights.value.includes('edit_plan_treatment') || rights.value.includes('edit_plan_treatment_limited'))

const editPlanTreatment = () => {
  router.push({
    name: 'TreatmentPlanFullCard',
    params: {
      patientId: planTreatment.value.client_id,
      planId: planTreatment.value.planning_id,
    }
  })
}
</script>
